import React from "react";
import { Switch, Route, BrowserRouter as Router } from "react-router-dom";
import LogoutContainer from "../../../components/login/LogoutContainer";
import AuthenticatedRouter from "./AuthenticatedRouter";
import { connect } from 'react-redux';
import { removeNotifications } from './miscActions'
import Loading from "../../../commons/components/utils/Loading";
import NotificationsViewer from "../../../components/layout/NotificationsViewer";
import "./AppRouter.css";
import { translate } from 'react-i18next';
import DocumentTitle from 'react-document-title';
import OnBoardingContainer from "../../../components/onboarding/OnBoardingContainer";
import FeedbackRouter from "./FeedbackRouter";
import isFeedbackCenterInStandaloneMode from "../../../components/feedback/FeedbackCenterUtil";
import GiveNps from "../../../components/feedback/nps/GiveNps";
import { firePageView, identify, initialize } from "../../../commons/components/utils/trackers";
import SetPassword from "../../../components/login/SetPassword";
import LeftComment from "../../../components/feedback/nps/LeftComment/LeftComment";
import CookiesDisclaimer from '../../../components/CookiesDisclaimer/CookiesDisclaimer'
import GiveNpsInOneStep from "../../../components/feedback/nps/GiveNpsInOneStep";
import ReporterComponent, {errorAction} from "../../../commons/reporter/reporter"
import ReviewLeaderboardEmployeeScreen from "../../../components/reviewLeaderBoard/ReviewLeaderBoardStandaloneScreen/ReviewLeaderboardEmployeeScreen";
import { envConfig } from '../../../config/config';
import { checkExistingSession } from '../../../api/oAuthApi';
import { loginSuccess } from '../../../components/login/loginActions';
import { useSessionExpired } from '../../../commons/utils/useSessionExpired';
import LoginContainer from "../../../components/login/LoginContainer";
import { getTokenSSO } from "../../../api/securityApi";
// --- Clear storage before creating the store ---

(async () => {
  const persisted = localStorage.getItem('persist:local');
  if (persisted) {
    // The storage is doubly serialized
    const persistedObj = JSON.parse(persisted);
    const persistedAdmin = persistedObj.admin ? JSON.parse(persistedObj.admin) : null;

    // Call the backend to get the real user from the HTTP-only cookie
    try {
      const currentAdmin = await checkExistingSession();
      // Check if user ID differs between persisted and current session
      if (persistedAdmin && persistedAdmin.id !== currentAdmin.id) {
        localStorage.removeItem('persist:local');
        localStorage.removeItem('persist:session');
      }
    } catch (e) {
      // If there is no valid session, also clear
      localStorage.removeItem('persist:local');
      localStorage.removeItem('persist:session');
    }
  }
})();

class AppRouter extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			reSized: true,
			checkingSession: false,
			sessionChecked: false
		}
	}

	handleResize = () => {
		//amp en master esto estaba comentado
		this.setState({ reSized: !this.state.reSized })
		const classes = document.getElementsByTagName("body")[0].classList;
		if (window.innerWidth < 769) {
			classes.add('body-small');
		} else {
			classes.remove('body-small');
		}
	};

	componentDidMount = () => {
		this.handleResize();
		this.handleAuthenticatedStyle(this.props.loggedIn);
		this.listener = window.addEventListener("resize", () => { this.handleAuthenticatedStyle(this.props.loggedIn); this.handleResize() });

		initialize();

		firePageView();
		identify(this.props.loggedAdmin, this.props.company ? this.props.company.signUpDate : undefined)
	};
	componentWillUnmount = () => {
		window.removeEventListener("resize", this.listener);
	};

	handleAuthenticatedStyle = (loggedIn) => {
		const classes = document.getElementById('wrapper').classList;
		if (loggedIn) {
			if (window.location.href.indexOf('feedback') === -1)
				classes.add('authenticated');
			classes.remove('login');
			classes.remove('fill-height');
		} else {
			classes.remove('authenticated');
			classes.add('fill-height');
			classes.add('login');
		}
	};

	componentDidCatch(error, info){
		this.props.errorAction({error, info})
	}

	checkSessionIfNeeded = async () => {

		if (this.state.sessionChecked || this.state.checkingSession) {
			return this.props.loggedIn;
		}
		this.setState({ checkingSession: true });

		try {
			// Pide el token principal (JWT) al restaurar sesión
			const auth = await checkExistingSession(true);
			const admin = auth.administrator;
			
			// Check if persisted user differs from current session user
			const persisted = localStorage.getItem('persist:local');
			if (persisted) {
				const persistedObj = JSON.parse(persisted);
				const persistedAdmin = persistedObj.admin ? JSON.parse(persistedObj.admin) : null;
				if (persistedAdmin && persistedAdmin.id !== admin.id) {
					localStorage.removeItem('persist:local');
					localStorage.removeItem('persist:session');
					window.location.reload();
					return false;
				}
			}
			
			// Update Redux state (no token needed - using HTTP-only cookies)
			this.props.loginSuccess({ 
				administrator: admin, 
				token: auth.token // No JWT token stored - using HTTP-only cookies
			}, '');

			this.setState({ sessionChecked: true, checkingSession: false });
			return true;
		} catch (error) {
			this.setState({ sessionChecked: true, checkingSession: false });
			return false;
		}
	};

	ProtectedRoute = ({ children, ...props }) => {
		const [sessionChecked, setSessionChecked] = React.useState(false);
		const [isAuthenticated, setIsAuthenticated] = React.useState(this.props.loggedIn);

		React.useEffect(() => {
			const checkAuth = async () => {
				if (!sessionChecked) {
					const authResult = await this.checkSessionIfNeeded();
					setIsAuthenticated(authResult);
					setSessionChecked(true);
				}
			};
			checkAuth();
		}, [this.props.loggedIn, sessionChecked]);

		if (!sessionChecked || this.state.checkingSession) {
			return <Loading fullScreen={true} loading={true} />;
		}

		if (!isAuthenticated) {
			window.location.href = this.getV2LoginUrl();
			return <div className="text-center p-4">Redirigiendo al login...</div>;
		}

		return children;
	};

	getV2LoginUrl = () => {
		return `${envConfig.v2LoginUrl}`;
	};

	getV2LogoutUrl = () => {
		return `${envConfig.v2LogoutUrl}`;
	};

	render() {
		const SessionExpiredHandler = () => {
			useSessionExpired();
			return null;
		};
		
		//amp en master esta linea estaba descomentada
		//this.handleResize();
		this.handleAuthenticatedStyle(this.props.loggedIn);

		const title = this.props.t("application.title");
		
		return (
			<DocumentTitle title={title}>
				<React.Fragment>
					<SessionExpiredHandler />
					<Loading fullScreen={true} loading={this.props.loading} />
					<Router>
						<NotificationsViewer notifications={this.props.notifications} removeNotifications={this.props.removeNotifications} />
						<Switch>
							<Route path={`/setPassword`} component={SetPassword} />
							<Route path={'/nps'} component={GiveNps} ></Route>
							<Route path={'/left-comment'} component={LeftComment} ></Route>
							<Route path={'/wizard'} component={OnBoardingContainer} />
							<Route path={'/nps-one-step'} component={GiveNpsInOneStep} ></Route>
							<Route path={'/error-report'} component={ReporterComponent} ></Route>
							<Route path={'/forgotPassword.php'} render={() => {
								window.location.href = `${envConfig.v1ForgotPasswordUrl}`;
								return null;
							}} />
							<Route path={'/employee-review-leaderboard'} component={ReviewLeaderboardEmployeeScreen}></Route>
							{isFeedbackCenterInStandaloneMode() && <Route path={'/'} render={(props) => (
								<this.ProtectedRoute>
									<FeedbackRouter {...props} />
								</this.ProtectedRoute>
							)}/>}
							<Route path={'/login*'} render={() => <LoginContainer/>}/>
							
							<Route path={'/logout*'} component={LogoutContainer} />
							<Route path={'/'} render={(props) => (
								<this.ProtectedRoute>
									<AuthenticatedRouter {...props} />
								</this.ProtectedRoute>
							)}/>
						</Switch>
					</Router>
					<CookiesDisclaimer></CookiesDisclaimer>
				</React.Fragment>
			</DocumentTitle>
		)
	}
}

const mapStateToProps = (state) => {
	return {
		loggedAdmin: state.login.admin,
		loggedIn: state.login.loggedIn,
		loading: state.misc.loading,
		currentError: state.misc.error,
		notifications: state.misc.notifications,
		company: state.application.selectedCompany
	}
}

export default connect(mapStateToProps, { removeNotifications, errorAction, loginSuccess })(translate('common')(AppRouter))
